import { defaultApi } from '../apis';

export enum ActivationStatus {
  Active = 'Active',
  Expired = 'Expired',
  Invalid = 'Invalid',
  Disabled = 'Disabled',
}

export interface ActivationCheckResult {
  isActivated: boolean;
  status: ActivationStatus;
  message?: string;
}

export const checkActivation = async (): Promise<ActivationCheckResult> => {
  try {
    const response = await defaultApi.getAboutInfoInfoApplicationAboutGet();
    const aboutInfo = response.data;
    const activation = aboutInfo.activation;

    if (!activation) {
      return { isActivated: true, status: ActivationStatus.Active };
    }

    const isActivated =
      activation.status === ActivationStatus.Active || activation.status === ActivationStatus.Disabled;

    return {
      isActivated,
      status: activation.status as ActivationStatus,
      message: activation.message ?? undefined,
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error checking activation status:', error);
    // On error, assume activated to not block users unnecessarily
    return { isActivated: true, status: ActivationStatus.Active };
  }
};
